import { render, staticRenderFns } from "./FormContactReview.vue?vue&type=template&id=3c6939b2&"
import script from "./FormContactReview.vue?vue&type=script&lang=js&"
export * from "./FormContactReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports